import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { NoData, Table } from 'src/tables/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { UserSetting } from 'src/WebApiController';

import { ReportTableV2Props } from '../ReportTableCommon/ReportTableCommon.types';
import { useReportDetailsTableV2 } from '../ReportTableCommon/useReportDetailsTableV2';
import {
  ListingReportTableColumnDefContextProviderV2,
  useListingReportTableColumnDefV2,
} from './ListingReportTableColumnDefContextV2';

export const ListingReportTableV2 = ({
  report,
  reportValueTypes,
  ...rest
}: ReportTableV2Props) => {
  return (
    <ListingReportTableColumnDefContextProviderV2
      report={report}
      reportValueTypes={reportValueTypes}
    >
      <ListingReportTableInternal report={report} {...rest} />
    </ListingReportTableColumnDefContextProviderV2>
  );
};

const ListingReportTableInternal = (props: ReportTableV2Props) => {
  const { displayedColumnsConfig = [] } = useListingReportTableColumnDefV2();

  const { isReportConfigEmpty, tableProps, data } = useReportDetailsTableV2({
    ...props,
    displayedColumnsConfig,
  });

  return isReportConfigEmpty ? (
    <></>
  ) : data?.length > 0 ? (
    <ColumnResizingContextProvider
      userSettingId={UserSetting.ReportV2InventoryColumnWidths}
    >
      <Table {...tableProps} />
    </ColumnResizingContextProvider>
  ) : (
    <NoData>
      <Content id={ContentId.NoReportText} />
    </NoData>
  );
};

export default ListingReportTableV2;
